/**
 * Custom scrollbar onder de product recommendations carousel.
 * Track #f5eded, vulling #68223a (240px), positie volgt scroll.
 */
(function () {
  const FILL_WIDTH = 240;

  function findRecommendationsContainer() {
    return document.querySelector('.product-information .product-recommendations');
  }

  function findCarouselAndSlides(container) {
    const carousel = container?.querySelector('.resource-list__carousel');
    const slidesEl = carousel?.querySelector('slideshow-slides');
    return { carousel, slidesEl };
  }

  function injectScrollbar(container) {
    const { carousel, slidesEl } = findCarouselAndSlides(container);
    if (!carousel || !slidesEl) return null;

    if (container.querySelector('.recommendations-scrollbar')) return null;

    const wrap = document.createElement('div');
    wrap.className = 'recommendations-scrollbar';
    wrap.setAttribute('aria-hidden', 'true');
    const fill = document.createElement('div');
    fill.className = 'recommendations-scrollbar__fill';
    wrap.appendChild(fill);

    carousel.insertAdjacentElement('afterend', wrap);

    function updateFill() {
      const trackWidth = wrap.offsetWidth;
      const scrollLeft = slidesEl.scrollLeft;
      const maxScroll = slidesEl.scrollWidth - slidesEl.clientWidth;

      const actualFillWidth = Math.min(FILL_WIDTH, trackWidth);
      fill.style.width = `${actualFillWidth}px`;

      if (maxScroll <= 0) {
        wrap.style.display = 'none';
        return;
      }
      wrap.style.display = '';

      const fillMaxLeft = Math.max(0, trackWidth - actualFillWidth);
      const left = (scrollLeft / maxScroll) * fillMaxLeft;
      fill.style.left = `${Math.round(left)}px`;
    }

    slidesEl.addEventListener('scroll', updateFill, { passive: true });
    window.addEventListener('resize', updateFill);

    updateFill();
    return { wrap, slidesEl, updateFill };
  }

  function observeRecommendations() {
    const container = findRecommendationsContainer();
    if (!container) return;

    function tryInject() {
      if (container.dataset.recommendationsPerformed !== 'true') return false;
      const injected = injectScrollbar(container);
      return Boolean(injected);
    }

    const observer = new MutationObserver(function () {
      if (tryInject()) observer.disconnect();
    });

    observer.observe(container, {
      attributes: true,
      attributeFilter: ['data-recommendations-performed'],
      childList: true,
      subtree: true
    });

    if (tryInject()) observer.disconnect();
    else {
      requestAnimationFrame(function () {
        if (tryInject()) observer.disconnect();
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeRecommendations);
  } else {
    observeRecommendations();
  }
})();
